import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  TextField,
  Button,
  useTheme,
  Stack,
} from '@mui/material'
import { useAuth } from 'auth'
import logger from 'logger'

import InputLabel from 'components/atoms/InputLabel'

const PasswordForgot = ({
  setView,
  state,
  setState,
  error,
  setError,
  setFetching,
  fetching,
  authErrorMapping,
}) => {
  const theme = useTheme()
  const { t } = useTranslation('auth')
  const { AmplifyAuth } = useAuth()

  const handleInputChange = (event) => {
    setState((s) => ({ ...s, [event.target.name]: event.target.value }))
  }

  const handlePasswordForgot = async (event) => {
    try {
      setFetching(true)
      setError(null)
      await AmplifyAuth.forgotPassword(state.email)
      setView('confirmResetPassword')
    } catch (e) {
      if (e.name === 'AuthError') {
        setError(authErrorMapping[e.log] || e.log)
        return
      }
      if (e.code === 'CodeMismatchException') {
        setError(e.code)
        return
      }
      logger.error(e)
      setError(e.code)
    } finally {
      setFetching(false)
    }
  }

  return (
    <Stack
      width="50%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        maxWidth: 400,
      }}
    >
      <Typography variant="h4" sx={{ pb: 1 }}>
        <strong>{t('headers.passwordForgot.title')}</strong>
      </Typography>
      <Typography
        textAlign="center"
        style={{ color: theme.palette.error.dark }}
        mb={5}
      >
        {t('messagePasswordForgot', state)}
      </Typography>
      <Box sx={{ width: 1 }}>
        <InputLabel
          label={t('attributes.email.label')}
          inputId="forgot-email"
          sx={{ textAlign: 'left' }}
        />
        <TextField
          id="forgot-email"
          size="small"
          placeholder={t('attributes.email.placeholder')}
          name="email"
          fullWidth
          value={state.email}
          onChange={handleInputChange}
          disabled={fetching}
          InputProps={{
            'data-testid': 'passwordForgot-email',
          }}
        />
      </Box>
      <Box mb={5} />
      <Button
        fullWidth
        color="primary"
        variant="contained"
        disabled={fetching}
        data-testid="passwordForgot-button"
        onClick={handlePasswordForgot}
      >
        {t('buttons.passwordForgot')}
      </Button>
      {error && (
        <Typography
          textAlign="center"
          p={[3]}
          style={{ color: theme.palette.error.light }}
          data-testid="passwordForgot-error"
        >
          {t(`errors.${error}`, state)}
        </Typography>
      )}
      <Box mb={5} />
      <Typography textAlign="center">
        <Trans
          t={t}
          i18nKey="messageChangeAccount"
          components={{
            action: (
              <Typography
                variant="span"
                color="primary"
                data-testid="passwordForgot-backToSignin"
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontWeight: 'bold',
                }}
                onClick={() => {
                  setState((s) => ({
                    ...s,
                    confirmCode: '',
                    password: '',
                    passwordConfirm: '',
                  }))
                  setView('signIn')
                }}
              />
            ),
          }}
        />
      </Typography>
    </Stack>
  )
}

export default PasswordForgot
